
/* eslint-disable max-classes-per-file */
export default class DeviceInfo {
  code: string;

  id: number;

  name: string;

  constructor(id: number) {
    this.code = '';
    this.id = id;
    this.name = '';
  }
}